import { cc, MapboxAPIClass } from "@lib/common";

export const MapboxAPI = new MapboxAPIClass({ api_key: cc.mapbox.apiKey });
